// extracted by mini-css-extract-plugin
var _1 = "VOa8I";
var _2 = "DEQdJ";
var _3 = "zSlUZ";
var _4 = "a7Z3n";
export { _1 as "completeIcon", _2 as "flagButtonColor", _3 as "flagButtonFilledColor", _4 as "flagFilledColor" }
